export const API_BASE_URL = process.env.NEXT_PUBLIC_MAINAPI_URL;
export const API_BASEMOBIL_URL = process.env.NEXT_PUBLIC_MOBILAPI_URL;
export const SECRET_KEY = process.env.NEXT_PUBLIC_SECRET_KEY;
